import { render, staticRenderFns } from "./CropperZoomer.vue?vue&type=template&id=5bfcab34"
import script from "./CropperZoomer.vue?vue&type=script&lang=js"
export * from "./CropperZoomer.vue?vue&type=script&lang=js"
import style0 from "./CropperZoomer.vue?vue&type=style&index=0&id=5bfcab34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports